
import {useSelector} from 'react-redux'
import { RootState } from "../../../../setup/redux/RootReducer";
import {useState,useEffect} from 'react' 
import { GetCustomerDetail } from '../redux/CustomerOperations'; 
import {  useDispatch } from "react-redux"; 
import {setCustomerDetail} from '../../searchShowCustomer/redux/CustomerDetailSlice'
import {CustomerDetailClass} from '../models/CustomerModels'

export default function CustomerList() {

    const customerList = useSelector((state: RootState) => state.customerListReducer);
    const dispatch = useDispatch();
    const [currentId, setCurrenetId] = useState();
    const [detailErrorStr, setDetailErrorStr] = useState("");

    const [previewLoading, setPreviewLoading] = useState(false)

    useEffect(() => {
        setDetailErrorStr("");
        setPreviewLoading(false);
    }, [customerList])

    function handleChange(e:any) {
        console.log(e);
        const {name, value} = e.target;
        console.log("Value =>>",value);
        setCurrenetId(value);
    }

    const handleSubmission = async () => {
        setPreviewLoading(true);
        setDetailErrorStr("");
        dispatch(setCustomerDetail(new CustomerDetailClass()))
        if(currentId != null && currentId != ""){
            let customer = customerList.customerList.find(x=> x.CardNumber == currentId);
            if(customer != null){
                let response:any = await GetCustomerDetail(customer);
                if(response.data != null){
                    if(response.data.Status != "SUCCESS"){
                        setDetailErrorStr(response.data.Detail);
                    }else{
                        dispatch(setCustomerDetail(response.data.Detail));
                    }
                }else{
                    setDetailErrorStr("Servisten yanıt alınamadı");
                }
              
            }
        }
        setPreviewLoading(false);
    }

    console.log("CustomerList =>>",customerList)
    return(
        <div>
                 {detailErrorStr != "" && detailErrorStr != null && 
                 <div className="col-xxl-12">
                    <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                            <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
                                <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                        <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
                                        <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                    </svg>
                                </span>
                            </span>
                            <div className="d-flex flex-column">
                                <h5 className="mb-1">Dikkat</h5>
                                <span>{detailErrorStr}</span>
                            </div>
                    </div>
            </div>}
            {customerList.customerList != null && customerList.customerList != undefined && customerList.customerList.length > 0 && 
             <table className="table table-hover table-rounded table-striped border gy-4 gs-7" style={{marginTop:20,marginBottom:20}}>
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th></th>
                        <th></th>
                        <th>Ticari Ünvan</th>
                        <th>Kart No</th>
                        <th>Müşteri No</th>
                        <th>Email</th>
                        <th>Cep No</th>
                        <th>Sabit No</th>
                        <th>Satın Alma Yetkilisi Adı Soyadı</th>
                        <th>Vergi No</th>
                        <th>Blok Kodu</th>
                    </tr>
                </thead>
                <tbody>  
                {customerList.customerList.map(customer => ( 
                 <>
                    <tr key={customer.CardNumber} style={{color:(customer.IsBloked == false ? (customer.IsActive ? 'black' : 'orange'): 'red')}}>
                        <td>
                            <div className="form-check form-check-custom form-check-solid" >
                                <input className="form-check-input" id="rd1" type="radio" name="customerRadio" value={customer.CardNumber} onChange={(event) => handleChange(event)}/>
                            </div>
                        </td>
                        <td>
                            {customer.Type == "1" ?<span className="badge badge-light-success fs-8 fw-bolder">Bireysel<span style={{color: '#rgb(9 73 253)'}}>({customer.AUTH_PERSON_ID == "0"  ? "M" : "S"})</span></span>
                                                  :<span className="badge badge-light-primary fs-8 fw-bolder">Kurumsal<span style={{color: '#rgb(9 73 253)'}}>({customer.AUTH_PERSON_ID == "0"  ? "M" : "S"})</span></span>
                            }
                        </td>
                        <td>{customer.BrandName}</td>
                        <td>{customer.CardNumber}</td>
                        <td>{customer.StoreKey}-{customer.CustomerNumber}</td>
                        <td>{customer.Email}</td>
                        <td>{customer.MobilePhoneNumber}</td>
                        <td>{customer.PhoneNumber}</td>
                        <td>{customer.ShortName}</td>
                        <td>{customer.TaxNumber}</td>
                        <td>{customer.BlockedCode}</td>
                    </tr>
                   </>
                ))}
                <tr>
                    <td colSpan={11}>
                        <button className="btn btn-success" onClick={handleSubmission} disabled={previewLoading} style={{fontWeight:'normal'}}>
                                                    <svg style={{ marginRight:3,width: 13,marginBottom:1}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cloud-upload" viewBox="0 0 16 16">
                                                         <path fillRule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                         <path fillRule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                                    </svg>
                                                    {!previewLoading && <span className='indicator-label'>Verileri Kontrol Et</span>}
                                                    {previewLoading && (
                                                        <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                                                        Detaylar alınıyor...
                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                        </span>
                                                    )} 
                        </button>
                    </td>
                </tr>
                </tbody>
            </table> 
            }
        </div>
    )
}